import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "92383c60-84dc-41cf-b8b3-de2e873651a9", content: "Increased", options: {} },
  { id: "95ab1891-48ef-449a-acfb-94e272338655", content: "Decreased", options: {} },
  {
    id: "0a12ceb3-e010-4415-a3a6-f79abe00f496",
    content: "The same because the NC doed not depend on the sound pressure level",
    options: {},
  },
];

export const task: Task = {
  id: "f5333839-a700-41ae-af42-095aedabf54e",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  solutionType: "select",
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["95ab1891-48ef-449a-acfb-94e272338655"],
};
